import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgExternal = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M20.2501 9.75L21.7501 8.25V2.25H15.7501L14.2501 3.75H19.2001L12.2251 10.725L13.2751 11.775L20.2501 4.8V9.75ZM4.5 21.75H18C19.275 21.75 20.25 20.775 20.25 19.5V12.75H18.75V19.5C18.75 19.95 18.45 20.25 18 20.25H4.5C4.05 20.25 3.75 19.95 3.75 19.5V6C3.75 5.55 4.05 5.25 4.5 5.25H11.25V3.75H4.5C3.225 3.75 2.25 4.725 2.25 6V19.5C2.25 20.775 3.225 21.75 4.5 21.75Z",
		fill: "currentColor"
	})
});
export default SvgExternal;
